LabelState = require 'app/scripts/view-models/label-state'
{ track } = require '@trello/analytics'

module.exports.labelClick = (e) ->
  if e && (e.ctrlKey || e.metaKey || e.shiftKey)
    return
  wasShowingLabelText = LabelState.getShowText()
  track(
    "Toggle Labels Text on Card Front",
    if wasShowingLabelText then "Hide" else "Show",
    @model.getBoard()?.id,
    "click-label"
  )
  e.preventDefault()
  e.stopPropagation()

  LabelState.toggleText()

module.exports.labelMouseEnter = (e) ->
  @$el.addClass('card-labels-hover')

module.exports.labelMouseLeave = (e) ->
  @$el.removeClass('card-labels-hover')
